import type { PredefinedValueType } from "app/pages/sales-intelligence/sub-modules/management/store/type";

import { dynamicsEnrichmentQueryKeys } from "../impl/dynamics/query/key-factory";
import dynamicsEnrichmentAPIService from "../impl/dynamics/services/api/dynamicsEnrichmentApiService";
import { hubspotEnrichmentQueryKeys } from "../impl/hubspot/queries/queryKeyFactory";
import hubspotEnrichmentAPIService from "../impl/hubspot/services/api/hubspotEnrichmentAPIService";
import { salesforceEnrichmentQueryKeys } from "../impl/salesforce/query/key-factory";
import sfEnrichmentApiService from "../impl/salesforce/services/api/sfEnrichmentApiService";
import type { ICrmEnrichmentQueryKeyFactory } from "../query/key-factory/types";
import type { ICrmEnrichmentAPIService } from "../services/api/types";
import type {
    CrmEnrichmentJobRefreshPeriod,
    CrmEnrichmentJobType,
    CrmEnrichmentSource,
    CrmProvider,
    LeadScoreRefreshDataInterval,
    Operator,
} from "../types/types";

export const CRM_ENRICHMENT_CONTENT_ID: Readonly<Record<CrmProvider, string>> = {
    salesforce: "sf",
    hubspot: "hs",
    dynamics: "msd",
};

export const QUERY_KEYS_BY_CRM: Record<CrmProvider, ICrmEnrichmentQueryKeyFactory> = {
    hubspot: hubspotEnrichmentQueryKeys,
    salesforce: salesforceEnrichmentQueryKeys,
    dynamics: dynamicsEnrichmentQueryKeys,
};

export const API_SERVICE_BY_CRM: Record<CrmProvider, ICrmEnrichmentAPIService> = {
    hubspot: hubspotEnrichmentAPIService,
    salesforce: sfEnrichmentApiService,
    dynamics: dynamicsEnrichmentAPIService,
};

export const OPERATOR_OPTIONS: Operator[] = [
    "equals",
    "notEquals",
    "contains",
    "notContains",
    "greater",
    "lower",
    "empty",
    "notEmpty",
];

export const OPERATOR_BY_DATA_TYPE: Record<PredefinedValueType, Operator[]> = {
    Date: ["equals", "notEquals", "greater", "lower", "empty", "notEmpty"],
    DateTime: ["equals", "notEquals", "greater", "lower", "empty", "notEmpty"],
    Numeric: ["equals", "notEquals", "greater", "lower", "empty", "notEmpty"],
    Text: ["equals", "notEquals", "contains", "notContains", "empty", "notEmpty"],
    Boolean: ["equals", "notEquals", "empty", "notEmpty"],
    Picklist: ["equals", "notEquals", "empty", "notEmpty"],
    Reference: ["equals", "notEquals", "empty", "notEmpty"],
};

export const MAX_FILTERS_QUANTITY = 10;

export const JOB_TYPE_OPTIONS: readonly CrmEnrichmentJobType[] = ["instant", "scheduled"];

export const JOB_REFRESH_PERIOD_OPTIONS: readonly CrmEnrichmentJobRefreshPeriod[] = [
    "never",
    "asSoonAsPossible",
    "twoMonths",
    "threeMonth",
    "sixMonth",
];

export const JOB_ENRICHMENT_LEVEL_OPTIONS: readonly CrmEnrichmentSource[] = ["company", "website"];

export const LEAD_SCORE_REFRESH_DATA_INTERVAL_OPTIONS: readonly LeadScoreRefreshDataInterval[] = [
    "daily",
    "weekly",
    "monthly",
];

export const JOBS_POLLING_INTERVAL_MS = 5 * 1000;

export const CrmErrorStatus = {
    configurationError: 422,
} as const;
